import { render } from "./ContactUs.vue?vue&type=template&id=35f6221a&scoped=true"
const script = {}

import "./ContactUs.vue?vue&type=style&index=0&id=35f6221a&scoped=true&lang=css"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f6221a"]])

export default __exports__